(function () {
  'use strict';

  function positiveNumber(value) {
    var raw = String(value == null ? '' : value).trim().replace(/[\s\u00A0\u202F\u2009]/g, '');
    if (!/^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(raw)) return null;
    var parsed = Number(raw.replace(',', '.'));
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function nonNegativeInteger(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!/^\d+$/.test(raw)) return null;
    var parsed = Number(raw);
    return Number.isSafeInteger(parsed) ? parsed : null;
  }

  function languageCode() {
    var locale = (typeof window !== 'undefined' && window.Shopify && window.Shopify.locale)
      || (typeof document !== 'undefined' && document.documentElement && document.documentElement.lang)
      || 'de';
    var lang = String(locale).toLowerCase().split('-')[0];
    return lang === 'nl' || lang === 'en' ? lang : 'de';
  }

  function displayUnit(value) {
    var raw = value == null ? '' : String(value).trim();
    var key = raw.toLowerCase().replace('²', '2');

    if (key === 'm2' || key === 'qm' || key === 'sqm') return 'm²';
    if (key === 'm1' || key === 'lfm') return 'lfm';
    var lang = languageCode();
    if (key === 'st' || key === 'stueck' || key === 'stück' || key === 'stuk' || key === 'piece') {
      return lang === 'nl' ? 'Stuk' : (lang === 'en' ? 'Piece' : 'Stück');
    }
    if (key === 'element' || key === 'elemente' || key === 'elementen' || key === 'elements') return 'Element';
    if (key === 'set' || key === 'sets') return 'Set';
    if (key === 'karton' || key === 'kartons' || key === 'doos' || key === 'dozen' || key === 'carton' || key === 'cartons') {
      return lang === 'nl' ? 'Doos' : (lang === 'en' ? 'Carton' : 'Karton');
    }
    if (key === 'paket' || key === 'pakete' || key === 'pakket' || key === 'pakketten' || key === 'package' || key === 'packages') {
      return lang === 'nl' ? 'Pakket' : (lang === 'en' ? 'Package' : 'Paket');
    }

    return raw || (lang === 'nl' ? 'Stuk' : (lang === 'en' ? 'Piece' : 'Stück'));
  }

  function quantityUnit(unit, quantity) {
    var label = displayUnit(unit);
    var key = label.toLowerCase();

    if (Number(quantity) === 1) return label;
    var lang = languageCode();
    if (key === 'stück' || key === 'stuk' || key === 'piece') return lang === 'nl' ? 'Stuks' : (lang === 'en' ? 'Pieces' : 'Stück');
    if (key === 'element') return lang === 'nl' ? 'Elementen' : (lang === 'en' ? 'Elements' : 'Elemente');
    if (key === 'set') return 'Sets';
    if (key === 'karton' || key === 'doos' || key === 'carton') return lang === 'nl' ? 'Dozen' : (lang === 'en' ? 'Cartons' : 'Kartons');
    if (key === 'paket' || key === 'pakket' || key === 'package') return lang === 'nl' ? 'Pakketten' : (lang === 'en' ? 'Packages' : 'Pakete');

    return label;
  }

  function rounded(value) {
    return Math.round(value * 10000) / 10000;
  }

  function normalizedPiecesFor(value, min, increment) {
    var safeMin = Math.max(1, parseInt(min, 10) || 1);
    var safeIncrement = Math.max(1, parseInt(increment, 10) || 1);
    var desired = Math.max(safeMin, Math.ceil(Number(value) || safeMin));
    return safeMin + Math.ceil((desired - safeMin) / safeIncrement) * safeIncrement;
  }

  function calculateAreaOrder(requested, factor, wasteEnabled, wastePercent, min, increment, max) {
    var target = rounded(requested * (wasteEnabled ? 1 + (wastePercent / 100) : 1));
    var desired = normalizedPiecesFor(Math.ceil((target - 1e-12) / factor), min, increment);
    var pieces = max == null ? desired : Math.min(desired, max);
    return {
      requested: rounded(requested),
      target: target,
      desired: desired,
      pieces: pieces,
      actual: rounded(pieces * factor),
      limited: desired > pieces || max === 0
    };
  }

  function adjustNeedForDelivery(existingNeed, deliveryArea, wasteEnabled, wastePercent) {
    var multiplier = wasteEnabled ? 1 + (wastePercent / 100) : 1;
    var maximumCoveredNeed = rounded(deliveryArea / multiplier);
    var need = positiveNumber(existingNeed);
    return need == null ? maximumCoveredNeed : Math.min(rounded(need), maximumCoveredNeed);
  }

  function formatted(value) {
    var n = Math.round((Number(value) + Number.EPSILON) * 100) / 100;
    if (!Number.isFinite(n)) n = 0;
    var str = Math.abs(n - Math.round(n)) < 1e-9
      ? String(Math.round(n))
      : n.toFixed(2);
    return languageCode() === 'en' ? str : str.replace('.', ',');
  }

  function formattedMoney(cents, currency) {
    var value = Number(cents);
    var currencyCode = currency || 'EUR';

    if (!Number.isFinite(value)) return '';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value / 100);
    } catch (error) {
      return formatted(value / 100) + ' ' + currencyCode;
    }
  }

  function labels() {
    var lang = languageCode();

    if (lang === 'nl') {
      return {
        wasteLabel: '{percent}% snijverlies',
        wasteProp: '{percent}% meegerekend',
        rounded: 'Afgerond op {pieces} {unit}: u ontvangt {area} m².',
        stock: 'Maximaal beschikbaar: {n} {unit} ({area} m²). Uw invoer is automatisch aangepast.',
        reserveUnavailable: 'Voor 10% snijverlies is bij deze hoeveelheid onvoldoende voorraad beschikbaar.',
        cartFull: 'De maximaal beschikbare hoeveelheid van dit artikel zit al in uw winkelwagen.',
        invalidArea: 'Voer een oppervlakte groter dan 0 in, bijvoorbeeld 5,5.',
        cartError: 'Bestelhoeveelheid kon niet worden bijgewerkt. Probeer het opnieuw.',
        maxReached: 'Meer is niet beschikbaar.'
      };
    }

    if (lang === 'en') {
      return {
        wasteLabel: '{percent}% allowance',
        wasteProp: '{percent}% included',
        rounded: 'Rounded up to {pieces} {unit}: you receive {area} m².',
        stock: 'Maximum available: {n} {unit} ({area} m²). Your entry was adjusted automatically.',
        reserveUnavailable: 'Not enough stock is available to add 10% allowance to this quantity.',
        cartFull: 'The maximum available quantity of this item is already in your cart.',
        invalidArea: 'Enter an area greater than 0, for example 5.5.',
        cartError: 'Quantity could not be updated. Please try again.',
        maxReached: 'No more stock available.'
      };
    }

    return {
      wasteLabel: '{percent} % Verschnitt',
      wasteProp: '{percent} % eingerechnet',
      rounded: 'Auf {pieces} {unit} aufgerundet: Sie erhalten {area} m².',
      stock: 'Maximal verfügbar: {n} {unit} ({area} m²). Ihre Eingabe wurde automatisch angepasst.',
      reserveUnavailable: 'Für 10 % Verschnitt ist bei dieser Menge nicht genügend Bestand verfügbar.',
      cartFull: 'Die maximal verfügbare Menge dieses Artikels befindet sich bereits in deinem Warenkorb.',
      invalidArea: 'Bitte eine Fläche größer als 0 eingeben, zum Beispiel 5,5.',
      cartError: 'Menge konnte nicht aktualisiert werden. Bitte erneut versuchen.',
      maxReached: 'Mehr ist nicht verfügbar.'
    };
  }

  function wastePropertyValue(percent) {
    return labels().wasteProp.replace('{percent}', String(percent));
  }

  function needPropertyValue(needArea) {
    return formatted(needArea) + ' m²';
  }

  function orderQuantityValue(pieces, unit, deliveryArea) {
    return pieces + ' ' + quantityUnit(unit, pieces) + ' (' + formatted(deliveryArea) + ' m²)';
  }

  var PROPERTY_KEYS = {
    de: { need: 'Flächenbedarf', waste: 'Zuschnittreserve', order: 'Menge' },
    nl: { need: 'Benodigde oppervlakte', waste: 'Snijverlies', order: 'Aantal' },
    en: { need: 'Required area', waste: 'Allowance', order: 'Quantity' }
  };
  var NEED_PROPERTY_KEYS = [
    PROPERTY_KEYS.de.need,
    PROPERTY_KEYS.nl.need,
    PROPERTY_KEYS.en.need,
    '1 Flächenbedarf',
    '1 Benodigde oppervlakte',
    '1 Required area',
    'Bedarfsfläche',
    'Bedarf'
  ];
  var WASTE_PROPERTY_KEYS = [
    PROPERTY_KEYS.de.waste,
    PROPERTY_KEYS.nl.waste,
    PROPERTY_KEYS.en.waste,
    '2 Zuschnittreserve',
    '2 Snijverlies',
    '2 Allowance',
    'Verschnitt'
  ];
  var ORDER_PROPERTY_KEYS = [
    PROPERTY_KEYS.de.order,
    PROPERTY_KEYS.nl.order,
    PROPERTY_KEYS.en.order,
    '3 Menge',
    '3 Aantal',
    '3 Quantity',
    '3 Bestellmenge',
    '3 Bestelhoeveelheid',
    '3 Order quantity',
    'Bestellmenge',
    'Bestelhoeveelheid',
    'Order quantity'
  ];

  function propertyKeys() {
    return PROPERTY_KEYS[languageCode()] || PROPERTY_KEYS.de;
  }

  function parseAreaProperty(value) {
    if (value == null) return null;
    return positiveNumber(String(value).replace(/m\s*[²2]/gi, ''));
  }

  function extractNeedArea(properties) {
    if (!properties) return null;

    for (var i = 0; i < NEED_PROPERTY_KEYS.length; i += 1) {
      var direct = parseAreaProperty(properties[NEED_PROPERTY_KEYS[i]]);
      if (direct != null) return rounded(direct);
    }

    var wasteText = '';
    for (var j = 0; j < WASTE_PROPERTY_KEYS.length; j += 1) {
      if (properties[WASTE_PROPERTY_KEYS[j]]) {
        wasteText = String(properties[WASTE_PROPERTY_KEYS[j]]);
        break;
      }
    }
    var needMatch = wasteText.match(/(?:Bedarf|benodigd|need)\s*([\d.,]+)\s*m/i);
    if (needMatch) {
      var parsed = positiveNumber(needMatch[1]);
      if (parsed != null) return rounded(parsed);
    }

    return null;
  }

  function clearM2PropertyKeys(properties) {
    NEED_PROPERTY_KEYS.concat(WASTE_PROPERTY_KEYS, ORDER_PROPERTY_KEYS, [
      'Lieferfläche',
      'm²',
      'm2'
    ]).forEach(function (key) {
      delete properties[key];
    });
  }

  function hasWasteProperties(properties) {
    return WASTE_PROPERTY_KEYS.some(function (key) {
      return Boolean(properties[key]);
    });
  }

  function notifyCartError(message) {
    console.warn('[m2-quantity]', message);

    var existing = document.getElementById('m2-cart-error-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'm2-cart-error-toast';
    toast.className = 'm2-cart-error-toast';
    toast.setAttribute('role', 'alert');
    toast.textContent = message;
    document.body.appendChild(toast);
    window.setTimeout(function () {
      if (toast.parentNode) toast.remove();
    }, 4000);
  }

  function controller(root) {
    var text = labels();
    var form = document.getElementById(root.dataset.formId);
    var quantity = root.querySelector('[data-m2-input]');
    var area = root.querySelector('[data-m2-area-input]');
    var summary = root.querySelector('[data-m2-summary]');
    var delivery = root.querySelector('[data-m2-delivery]');
    var piecesResult = root.querySelector('[data-m2-result-pieces]');
    var piecesUnit = root.querySelector('[data-m2-result-pieces-unit]');
    var needResult = root.querySelector('[data-m2-result-need]');
    var wasteResult = root.querySelector('[data-m2-result-waste]');
    var wasteResultLabel = root.querySelector('[data-m2-result-waste-label]');
    var wasteResultRow = root.querySelector('[data-m2-result-waste-row]');
    var areaResult = root.querySelector('[data-m2-result-m2]');
    var priceResult = root.querySelector('[data-m2-result-price]');
    var rounding = root.querySelector('[data-m2-rounding-note]');
    var wasteToggle = root.querySelector('[data-m2-waste-toggle]');
    var wasteWrap = wasteToggle && wasteToggle.closest('.m2-qty__waste');
    var wasteHint = root.querySelector('[data-m2-waste-hint]');
    var propWaste = root.querySelector('[data-m2-prop-waste]');
    var propNeed = root.querySelector('[data-m2-prop-need]');
    var propUnits = root.querySelector('[data-m2-prop-units]');
    var dataNode = root.querySelector('[data-m2-variants]');
    var variants = {};
    var syncing = false;

    if (!form || !quantity || !area || !dataNode) return null;

    var state = {
      factor: null,
      unit: 'Stück',
      max: null,
      requested: null,
      actual: null,
      pieces: 1,
      priceCents: null,
      currency: root.dataset.currency || 'EUR',
      areaInvalid: false,
      cartFull: false,
      stockLimited: false,
      wasteUnavailable: false,
      wasteEnabled: false,
      wastePercent: 10,
      min: Math.max(1, parseInt(quantity.getAttribute('min'), 10) || 1),
      increment: Math.max(1, parseInt(quantity.getAttribute('step'), 10) || 1),
      ruleMax: Number.isFinite(parseInt(quantity.getAttribute('max'), 10))
        ? parseInt(quantity.getAttribute('max'), 10)
        : null
    };

    try {
      variants = JSON.parse(dataNode.textContent || '{}');
    } catch (error) {
      return null;
    }

    function variantId() {
      var input = form.querySelector('[name="id"]');
      return input && input.value ? String(input.value) : null;
    }

    function maxPieces(info) {
      var inventoryMax = null;
      if (info && info.managed && String(info.policy).toLowerCase() !== 'continue') {
        var value = parseInt(info.quantity, 10);
        var inCart = parseInt(info.cartQuantity, 10);
        if (Number.isFinite(value)) inventoryMax = Math.max(0, value - (Number.isFinite(inCart) ? inCart : 0));
      }

      var rawMax = inventoryMax;
      if (state.ruleMax != null) rawMax = rawMax == null ? state.ruleMax : Math.min(rawMax, state.ruleMax);
      if (rawMax == null) return null;
      if (rawMax < state.min) return 0;

      return state.min + Math.floor((rawMax - state.min) / state.increment) * state.increment;
    }

    function cartContainsAllStock(info) {
      if (!info || !info.managed || String(info.policy).toLowerCase() === 'continue') return false;
      var inventory = parseInt(info.quantity, 10);
      var inCart = parseInt(info.cartQuantity, 10);
      return Number.isFinite(inventory) && inventory > 0 && Number.isFinite(inCart) && inCart >= inventory;
    }

    function normalizedPieces(value) {
      return normalizedPiecesFor(value, state.min, state.increment);
    }

    function wasteMultiplier() {
      return state.wasteEnabled ? 1 + (state.wastePercent / 100) : 1;
    }

    function setStockLimited(limited) {
      state.stockLimited = !!limited;
    }

    function setAreaValidity(valid) {
      state.areaInvalid = !valid;
      area.setCustomValidity(valid ? '' : text.invalidArea);
      if (valid) {
        area.removeAttribute('aria-invalid');
      } else {
        area.setAttribute('aria-invalid', 'true');
      }
    }

    function syncStockAvailability() {
      var unavailable = state.max === 0;
      var addButton = form.querySelector('buy-button .product-form__add-button');

      quantity.disabled = unavailable;

      if (!addButton) return;

      if (unavailable) {
        if (!addButton.disabled || addButton.dataset.m2StockDisabled === 'true') {
          addButton.disabled = true;
          addButton.dataset.m2StockDisabled = 'true';
        }
      } else if (addButton.dataset.m2StockDisabled === 'true') {
        addButton.disabled = false;
        addButton.removeAttribute('data-m2-stock-disabled');
      }
    }

    function renderStatusNote() {
      if (!rounding) return;

      var message = '';
      var isLimit = false;

      if (!state.areaInvalid && state.cartFull) {
        message = text.cartFull;
        isLimit = true;
      } else if (!state.areaInvalid && state.stockLimited) {
        var stockQuantity = state.max == null ? state.pieces : state.max;
        if (state.factor) {
          message = text.stock
            .replace('{n}', String(stockQuantity))
            .replace('{unit}', quantityUnit(state.unit, stockQuantity))
            .replace('{area}', formatted(rounded(stockQuantity * state.factor)));
        } else {
          message = (window.languages && window.languages.cartQuantityLimitReached) || text.maxReached;
        }
        isLimit = true;
      } else if (!state.areaInvalid && state.factor && state.requested != null && state.actual != null) {
        var target = state.wasteEnabled ? rounded(state.requested * wasteMultiplier()) : state.requested;
        if (state.actual > target + 0.000001) {
          message = text.rounded
            .replace('{pieces}', String(state.pieces))
            .replace('{unit}', quantityUnit(state.unit, state.pieces))
            .replace('{area}', formatted(state.actual));
        }
      }

      rounding.hidden = !message;
      rounding.classList.toggle('is-limit', isLimit);
      rounding.textContent = message;
    }

    function updateWasteAvailability() {
      var unavailable = false;

      if (
        state.factor
        && !state.wasteEnabled
        && state.requested != null
        && state.max != null
        && state.max > 0
      ) {
        var reserveTarget = rounded(state.requested * (1 + (state.wastePercent / 100)));
        var reservePieces = normalizedPieces(Math.ceil((reserveTarget - 1e-12) / state.factor));
        unavailable = reservePieces > state.max;
      }

      state.wasteUnavailable = unavailable;
      if (wasteToggle) {
        wasteToggle.disabled = !state.factor || state.max === 0 || unavailable;
      }
      if (wasteWrap) {
        wasteWrap.classList.toggle('is-disabled', unavailable);
      }
      if (wasteHint) {
        if (!wasteHint.dataset.defaultText) wasteHint.dataset.defaultText = wasteHint.textContent;
        wasteHint.textContent = unavailable ? text.reserveUnavailable : wasteHint.dataset.defaultText;
      }
    }

    function setProperties() {
      var keys = propertyKeys();

      if (propUnits) {
        propUnits.name = 'properties[' + keys.order + ']';
        propUnits.disabled = !state.factor;
        propUnits.value = state.factor && state.actual != null
          ? orderQuantityValue(state.pieces, state.unit, state.actual)
          : '';
      }

      if (propNeed) {
        propNeed.name = 'properties[' + keys.need + ']';
        propNeed.disabled = !state.factor || state.requested == null;
        propNeed.value = state.factor && state.requested != null
          ? needPropertyValue(state.requested)
          : '';
      }

      if (propWaste) {
        propWaste.name = 'properties[' + keys.waste + ']';
        propWaste.disabled = !state.wasteEnabled;
        propWaste.value = state.wasteEnabled
          ? wastePropertyValue(state.wastePercent)
          : '';
      }
    }

    function render() {
      if (!state.factor) return;

      syncing = true;
      var unitsLabel = quantityUnit(state.unit, state.pieces);
      var wasteArea = state.wasteEnabled && state.requested != null
        ? rounded(state.requested * (state.wastePercent / 100))
        : 0;
      quantity.value = String(state.pieces);
      if (piecesResult) piecesResult.textContent = String(state.pieces);
      if (piecesUnit) piecesUnit.textContent = unitsLabel;
      if (needResult) needResult.textContent = formatted(state.requested);
      if (wasteResult) wasteResult.textContent = formatted(wasteArea);
      if (wasteResultLabel) {
        wasteResultLabel.textContent = text.wasteLabel.replace('{percent}', String(state.wastePercent));
      }
      if (wasteResultRow) {
        var wasteUsed = state.wasteEnabled && state.requested != null
          && Math.abs(state.actual - state.requested) > 1e-9;
        wasteResultRow.hidden = !wasteUsed;
      }
      if (areaResult) areaResult.textContent = formatted(state.actual);
      if (priceResult && state.priceCents != null) {
        priceResult.textContent = formattedMoney(state.pieces * state.priceCents, state.currency);
      }
      root.querySelectorAll('[data-m2-sales-unit]').forEach(function (element) {
        element.textContent = unitsLabel;
      });

      renderStatusNote();
      updateWasteAvailability();
      setProperties();
      syncing = false;
    }

    function applyPieces(fromUser) {
      setAreaValidity(true);
      var typed = nonNegativeInteger(quantity.value);
      var desired = normalizedPieces(typed == null ? state.min : Math.max(typed, state.min));
      var pieces = desired;
      if (state.max != null) pieces = Math.min(pieces, state.max);
      if (state.max === 0) pieces = 0;

      state.pieces = pieces;

      if (!state.factor) {
        quantity.value = String(pieces);
        // A sold-out product already communicates its state through the disabled
        // purchase button. Only show the quantity-limit warning after a customer
        // actually tries to request more than the available stock.
        setStockLimited(!!fromUser && state.max != null && desired > pieces);
        renderStatusNote();
        return;
      }

      setStockLimited(desired > pieces || (typed != null && state.max != null && typed > state.max) || state.max === 0);

      state.actual = rounded(pieces * state.factor);

      if (fromUser || state.requested == null) {
        state.requested = state.actual;
        area.value = formatted(state.requested);
      } else {
        var covered = adjustNeedForDelivery(null, state.actual, state.wasteEnabled, state.wastePercent);
        if (state.requested > covered + 1e-9) {
          state.requested = covered;
          area.value = formatted(state.requested);
        }
      }

      render();
    }

    function applyArea(formatInput, preserveLimitNotice) {
      if (!state.factor) return;

      var requested = positiveNumber(area.value);
      if (requested == null) {
        setAreaValidity(false);
        renderStatusNote();
        return false;
      }

      setAreaValidity(true);
      var keepLimitNotice = preserveLimitNotice && state.stockLimited
        && state.requested != null && Math.abs(requested - state.requested) < 0.000001;

      var result = calculateAreaOrder(
        requested,
        state.factor,
        state.wasteEnabled,
        state.wastePercent,
        state.min,
        state.increment,
        state.max
      );
      state.pieces = result.pieces;
      state.actual = result.actual;
      state.requested = result.requested;
      if (result.limited) {
        state.requested = adjustNeedForDelivery(
          state.requested,
          state.actual,
          state.wasteEnabled,
          state.wastePercent
        );
      }
      setStockLimited(result.limited || keepLimitNotice);

      // Area input is always the customer need (Flächenbedarf), never the delivery area.
      // Writing actual here compounded Verschnitt on every blur/toggle/pieces sync.
      if (formatInput || result.limited) {
        area.value = formatted(state.requested);
      }
      render();
      return result.limited;
    }

    function refresh() {
      var info = variants[variantId()] || null;
      var factor = info && positiveNumber(info.factor);
      var salesUnit = info && info.salesUnit ? String(info.salesUnit).trim() : '';
      var variantUnit = info && info.unit ? String(info.unit).trim() : '';
      var priceCents = info ? parseInt(info.price, 10) : NaN;

      state.factor = factor && salesUnit ? factor : null;
      state.unit = displayUnit(state.factor ? salesUnit : (variantUnit || root.dataset.defaultUnit));
      state.max = maxPieces(info);
      state.cartFull = cartContainsAllStock(info);
      state.priceCents = Number.isFinite(priceCents) ? priceCents : null;
      state.wasteEnabled = Boolean(wasteToggle && wasteToggle.checked);
      root.classList.toggle('is-m2-active', !!state.factor);

      if (summary) summary.hidden = !state.factor;
      if (delivery) delivery.hidden = !state.factor;
      if (wasteWrap) wasteWrap.hidden = !state.factor;
      area.disabled = !state.factor || state.max === 0;
      if (wasteToggle) wasteToggle.disabled = !state.factor || state.max === 0;

      if (state.max != null) quantity.max = String(state.max);
      else quantity.removeAttribute('max');
      syncStockAvailability();

      if (state.cartFull) {
        state.stockLimited = false;
        state.wasteUnavailable = false;
        if (wasteToggle) wasteToggle.disabled = true;
        if (wasteWrap) wasteWrap.classList.add('is-disabled');
        if (wasteHint) {
          if (!wasteHint.dataset.defaultText) wasteHint.dataset.defaultText = wasteHint.textContent;
          wasteHint.textContent = text.reserveUnavailable;
        }
        renderStatusNote();
        return;
      }

      root.querySelectorAll('[data-m2-sales-unit]').forEach(function (element) {
        element.textContent = quantityUnit(state.unit, state.pieces);
      });

      if (!state.factor) {
        state.wasteUnavailable = false;
        if (propWaste) {
          propWaste.disabled = true;
          propWaste.value = '';
        }
        if (propNeed) {
          propNeed.disabled = true;
          propNeed.value = '';
        }
        if (propUnits) {
          propUnits.disabled = true;
          propUnits.value = '';
        }
        applyPieces();
        return;
      }

      if (root.dataset.m2PreservedArea) {
        state.wasteEnabled = root.dataset.m2PreservedWaste === 'true';
        if (wasteToggle) wasteToggle.checked = state.wasteEnabled;
        area.value = root.dataset.m2PreservedArea;
        delete root.dataset.m2PreservedArea;
        delete root.dataset.m2PreservedWaste;
        applyArea(true);
      } else if (positiveNumber(area.value) != null) {
        applyArea(true);
      } else {
        applyPieces();
      }
    }

    function applyAndFormatArea() {
      if (!syncing) applyArea(true, true);
    }

    area.addEventListener('input', function () {
      if (!syncing) applyArea(false);
    });
    area.addEventListener('focus', function () {
      area.select();
    });
    area.addEventListener('blur', applyAndFormatArea);
    area.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      applyAndFormatArea();
    });
    quantity.addEventListener('input', function () {
      if (!syncing) applyPieces(true);
    });
    quantity.addEventListener('change', function () {
      if (!syncing) applyPieces(true);
    });
    quantity.addEventListener('blur', function () {
      if (!syncing) applyPieces(true);
    });
    quantity.addEventListener('focus', function () {
      quantity.select();
    });
    if (wasteToggle) {
      wasteToggle.addEventListener('change', function () {
        if (syncing || !state.factor) return;
        if (wasteToggle.checked && state.wasteUnavailable) {
          wasteToggle.checked = false;
          updateWasteAvailability();
          return;
        }
        var requestedBeforeToggle = state.requested;
        state.wasteEnabled = wasteToggle.checked;
        if (requestedBeforeToggle != null) {
          var absoluteMinNeed = rounded(state.min * state.factor);
          var restoredNeed = (!state.wasteEnabled && requestedBeforeToggle < absoluteMinNeed - 1e-9)
            ? absoluteMinNeed
            : requestedBeforeToggle;
          area.value = formatted(restoredNeed);
        }
        applyArea(true);
      });
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-action="increase-picker-quantity"], [data-action="decrease-picker-quantity"], [data-action="increase-m2-area"], [data-action="decrease-m2-area"]');
      if (!button || !state.factor || state.max === 0) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      var increases = button.dataset.action === 'increase-picker-quantity' || button.dataset.action === 'increase-m2-area';
      var nextPieces = normalizedPieces(state.pieces + (increases ? state.increment : -state.increment));
      if (state.max != null) nextPieces = Math.min(nextPieces, state.max);
      if (nextPieces === state.pieces) {
        if (increases && state.max != null && state.max > 0) {
          setStockLimited(true);
          renderStatusNote();
        }
        return;
      }
      quantity.value = String(nextPieces);
      applyPieces(true);
    }, true);

    form.addEventListener('submit', function (event) {
      if (!state.factor) {
        if (!syncing) applyPieces(true);
        return;
      }
      if (!syncing) {
        if (document.activeElement === area) applyArea(true, true);
        else if (document.activeElement === quantity) applyPieces(true);
      }
      if (state.areaInvalid) {
        event.preventDefault();
        area.reportValidity();
        area.focus();
        return;
      }
      if (state.max === 0 || state.pieces < 1) {
        event.preventDefault();
        setStockLimited(true);
        renderStatusNote();
        return;
      }

      quantity.value = String(state.pieces);
      if (state.requested != null) {
        area.value = formatted(state.requested);
      }
      setProperties();
    }, true);

    function syncCartQuantities(cartQuantities) {
      var previousPieces = state.pieces;
      var wasCartFull = state.cartFull;
      Object.keys(variants).forEach(function (id) {
        variants[id].cartQuantity = cartQuantities[id] || 0;
      });
      refresh();
      if (wasCartFull && !state.cartFull && state.pieces === previousPieces) {
        setStockLimited(false);
        renderStatusNote();
      }
    }

    refresh();
    return { refresh: refresh, syncCartQuantities: syncCartQuantities };
  }

  var cartUpdateChain = Promise.resolve();
  var productCartSyncTimer = null;

  function m2CartInput(target) {
    if (!target) return null;

    var selector = target.closest('.quantity-selector');
    if (!selector) {
      var controls = target.closest('.mini-cart__quantity-controls, .line-item__quantity');
      selector = controls && controls.querySelector('.quantity-selector');
    }
    if (!selector || selector.classList.contains('quantity-selector--product')) return null;

    var input = selector.querySelector('.quantity-selector__value[data-m2-factor]');
    return input || null;
  }

  function m2CartProperties(input, quantity) {
    var factor = positiveNumber(input.dataset.m2Factor);
    var properties = null;

    try {
      var parsed = JSON.parse(input.dataset.lineProperties || '{}');
      if (Array.isArray(parsed)) {
        properties = {};
        parsed.forEach(function (property) {
          if (Array.isArray(property) && property.length > 1) {
            properties[property[0]] = property[1];
          }
        });
      } else if (parsed && typeof parsed === 'object') {
        properties = parsed;
      }
    } catch (error) {
      properties = null;
    }

    if (!factor || !properties || quantity < 1) return null;

    var unit = input.dataset.m2SalesUnit || 'Stück';
    var deliveryArea = rounded(quantity * factor);
    var hadWaste = hasWasteProperties(properties);
    var needArea = extractNeedArea(properties);
    if (needArea == null) needArea = hadWaste ? rounded(deliveryArea / 1.1) : deliveryArea;
    needArea = adjustNeedForDelivery(needArea, deliveryArea, hadWaste, 10);
    var keys = propertyKeys();

    clearM2PropertyKeys(properties);

    properties[keys.need] = needPropertyValue(needArea);
    if (hadWaste) properties[keys.waste] = wastePropertyValue(10);
    properties[keys.order] = orderQuantityValue(quantity, unit, deliveryArea);

    return properties;
  }

  function syncM2ProductCartState() {
    window.clearTimeout(productCartSyncTimer);
    productCartSyncTimer = window.setTimeout(function () {
      var roots = document.querySelectorAll('[data-m2-quantity]');
      if (!roots.length) return;

      var cartUrl = ((window.routes && window.routes.cartUrl) || '/cart') + '.js';
      fetch(cartUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('cart.js HTTP ' + response.status);
          return response.json();
        })
        .then(function (cart) {
          var quantities = {};
          (cart.items || []).forEach(function (item) {
            var id = String(item.variant_id);
            quantities[id] = (quantities[id] || 0) + item.quantity;
          });
          roots.forEach(function (root) {
            if (root._m2Controller) root._m2Controller.syncCartQuantities(quantities);
          });
        })
        .catch(function (error) {
          console.warn('[m2-quantity] Cart state sync failed:', error && error.message ? error.message : error);
        });
    }, 0);
  }

  function normalizedCartQuantity(input, rawValue) {
    var quantity = nonNegativeInteger(rawValue);
    if (quantity == null) return null;
    if (quantity === 0) return 0;

    var min = Math.max(1, parseInt(input.min, 10) || 1);
    var step = Math.max(1, parseInt(input.step, 10) || 1);
    quantity = normalizedPiecesFor(quantity, min, step);

    var max = parseInt(input.dataset.maxQuantity || input.max, 10);
    if (Number.isFinite(max)) {
      var normalizedMax = max < min ? 0 : min + Math.floor((max - min) / step) * step;
      quantity = Math.min(quantity, normalizedMax);
    }

    return quantity;
  }

  function updateM2CartLine(input, quantity) {
    var line = parseInt(input.dataset.line, 10);
    if (!Number.isFinite(line) || line < 1) return;

    var payload = {
      line: line,
      quantity: quantity
    };
    var properties = m2CartProperties(input, quantity);
    if (properties) {
      payload.properties = properties;
      input.dataset.lineProperties = JSON.stringify(properties);
    }
    input.dataset.currentValue = String(quantity);

    cartUpdateChain = cartUpdateChain
      .catch(function () {})
      .then(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        return fetch(((window.routes && window.routes.cartChangeUrl) || '/cart/change') + '.js', {
          body: JSON.stringify(payload),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (response) {
          if (!response.ok) {
            throw new Error('cart/change HTTP ' + response.status);
          }

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { scrollToTop: false }
          }));
        }).catch(function (error) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          notifyCartError(labels().cartError);
          // Re-sync UI from server so a failed change does not leave a stale qty.
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { scrollToTop: false }
          }));
          console.warn('[m2-quantity] Cart line update failed:', error && error.message ? error.message : error);
        });
      });
  }

  function cartStockMessage(input, quantity) {
    var unit = displayUnit(input.dataset.m2SalesUnit || 'Stück');
    var factor = positiveNumber(input.dataset.m2Factor);
    var area = factor ? formatted(rounded(quantity * factor)) : '';
    var message = labels().stock
      .replace('{n}', String(quantity))
      .replace('{unit}', quantityUnit(unit, quantity))
      .replace('{area}', area || '0');
    return message;
  }

  function onM2CartClick(event) {
    var button = event.target && event.target.closest
      ? event.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]')
      : null;
    var input = m2CartInput(button);
    if (!button || !input) return;

    var quantity;
    var current = parseInt(input.value, 10);
    if (button.dataset.quantity === '0') {
      quantity = 0;
    } else {
      var step = Math.max(1, parseInt(input.step, 10) || 1);
      var increase = button.dataset.action === 'increase-quantity';
      var requested = (Number.isFinite(current) ? current : 0) + (increase ? step : -step);
      quantity = normalizedCartQuantity(input, requested);
      if (increase && quantity != null && Number.isFinite(current) && quantity <= current) {
        notifyCartError(cartStockMessage(input, quantity));
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
    }
    if (quantity == null) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = String(quantity);
    updateM2CartLine(input, quantity);
  }

  function onM2CartChange(event) {
    var input = event.target.matches('.quantity-selector__value[data-m2-factor]')
      ? m2CartInput(event.target)
      : null;
    if (!input) return;

    var requested = nonNegativeInteger(input.value);
    var quantity = normalizedCartQuantity(input, input.value);
    if (quantity == null) {
      input.value = input.dataset.currentValue || input.min || '1';
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = String(quantity);
    if (requested != null && requested > quantity) {
      notifyCartError(cartStockMessage(input, quantity));
    }
    updateM2CartLine(input, quantity);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      adjustNeedForDelivery: adjustNeedForDelivery,
      calculateAreaOrder: calculateAreaOrder,
      m2CartProperties: m2CartProperties,
      normalizedCartQuantity: normalizedCartQuantity,
      normalizedPiecesFor: normalizedPiecesFor,
      nonNegativeInteger: nonNegativeInteger,
      positiveNumber: positiveNumber,
      rounded: rounded
    };
  }

  if (typeof document === 'undefined') return;

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-m2-quantity]').forEach(function (root) {
      if (!root._m2Controller) root._m2Controller = controller(root);
      else root._m2Controller.refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('variant:changed', function () {
    window.setTimeout(function () { init(document); }, 0);
  });

  document.addEventListener('theme:product:loaded', function (event) {
    init(event.target || document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  document.documentElement.addEventListener('click', onM2CartClick, true);
  document.documentElement.addEventListener('change', onM2CartChange, true);
  document.documentElement.addEventListener('product:added', syncM2ProductCartState);
  document.documentElement.addEventListener('cart:refresh', syncM2ProductCartState);
})();
